import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../shared";

@Injectable()
export class DataService_Inbox {
	constructor(private httpclientService: HttpclientService) {}

	InboxSelectList() {
		var postResult$ = new Subject();
		var url = "ReportInbox/InboxSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	InboxToggleRead(InboxID: number) {
		var postResult$ = new Subject();
		var url = "ReportInbox/InboxToggleRead?InboxID=" + InboxID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	InboxSelect(InboxID: number) {
		var postResult$ = new Subject();
		var url = "ReportInbox/InboxSelect?InboxID=" + InboxID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	InboxDelete(InboxID: number) {
		var postResult$ = new Subject();
		var url = "ReportInbox/InboxDelete?InboxID=" + InboxID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	InboxDeleteAll() {
		var postResult$ = new Subject();
		var url = "ReportInbox/InboxDeleteAll?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
